/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { loadStripe } from '@stripe/stripe-js';
import {
  CardElement,
  useStripe,
  useElements,
  Elements
} from '@stripe/react-stripe-js';
import axios from "axios";
import CommonVars from "../components/CommonVars";
import { 
    Box,
    Button,
    Heading,
    Text,
    Image,
    useToast,
    Input,
    Flex,
    VStack,
    Spinner
} from "@chakra-ui/react";

const stripePromise = loadStripe('pk_test_51LJXljCA5cqw1J4ETK5E1WUTMpU0k3KU5EcvtbSBm9LYl9hCSd1rtSEu7DOVqA7lGp2HzzPy6qT3I7c5Z9gGg9FZ00BSx8M1g5');

function PaymentScreen() {

    const [stripeData, setStripeData] = useState({});
    const [userData, setUserData] = useState([]);
    const [img_url, setImgurl] = useState('');
    const [pageloading, setPageLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [payLoading, setPayLoading] = useState(false);
    
    const { search } = useLocation(); 
      
    const paramsPrice = String(search.split("&")[1]);
    const priceToPay = parseInt((paramsPrice.split('=')[1]));
    const paramsAddress = String(search.split("=")[1]);
    const addressFilter = (paramsAddress.split("&")[0]);
    const userAddress = addressFilter.replace(/%20/gi, ' ');

   
    // console.log(userAddress);
    // console.log(priceToPay);
    // this is what you need
    const userid = parseInt(useParams().userid);
    const cartid = parseInt(useParams().cartid);

    const payToken = localStorage.getItem('token');

    // access backend to retrieve user detail entered when sign up
    const getUserData = async () => {
        axios.get(`${CommonVars.API_URL}/users/${userid}/`, { headers: { Authorization: `Bearer ${payToken}` } })
        .then((res) => {
            console.log(res.data[0]);
            setUserData(res.data[0]);
            setPageLoading(true);
        })
        .catch((error) => {
            console.log(error);
            if(error.response.status === 401) {
                window.location.replace("/unauthorized");
            }
        })
    }

    // set toast
    const toast = useToast();
    const id = 'disCode-toast';

    const getDiscountCode = async (e) => {
        e.preventDefault();
        const input = document.getElementById('discountCode');
        const inputDisCode = input.value;
        console.log(inputDisCode);
        if (inputDisCode){
            axios.get(`${CommonVars.API_URL}/user/${userid}/discounts`, 
                { headers: { Authorization: `Bearer ${payToken}` } 
            })
                .then((res) => {
                    setLoading(true);
                    console.log(res);
                    return axios.get(`${CommonVars.API_URL}/user/${userid}/discount-code?code=${inputDisCode}`, 
                        { headers: { Authorization: `Bearer ${payToken}` } 
                    });
                })
                .then((res) => {
                    console.log(res.data.discount_amt);
                    const discountAmt = res.data.discount_amt;
                    const totalDisc = priceToPay - discountAmt;
                    console.log(totalDisc);
                    if (!toast.isActive(id)) {
                        toast({
                            id,
                            title: 'Hooray!',
                            description: `${res.data.discount_code} discount code has been used!`,
                            status: 'success',
                            position: 'top',
                            duration: 3000,
                            isClosable: true,
                        });
                    };

                    axios.delete(`${CommonVars.API_URL}/user/${userid}/del-discount?code=${inputDisCode}`, 
                        { headers: { Authorization: `Bearer ${payToken}` },
                    });
                    
                    setTimeout(() => {
                        window.location.replace(`/users/${userid}/cart/${cartid}/payment?address=${userAddress}&total=${totalDisc}`);
                        setLoading(false);
                    }, 2000);
                })
                .catch((error) => {
                    if (!toast.isActive(id)) {
                        toast({
                            id,
                            title: 'Code Not found!',
                            description: "Your discount code does not exists!",
                            status: 'error',
                            position: 'top',
                            duration: 3000,
                            isClosable: true,
                        });
                    };
                    console.log(error);
                    setLoading(false);
                });
        } else {
            if (!toast.isActive(id)) {
                toast({
                    id,
                    title: 'Code Not found!',
                    description: "Please enter a discount code!",
                    status: 'error',
                    position: 'top',
                    duration: 3000,
                    isClosable: true,
                });
            };
            setTimeout(() => {
                setLoading(false);
            }, 600);
        };
    };
    
    const getCartTotalAmount = async () => {
        axios.get(`${CommonVars.API_URL}/users/${userid}/cart/${cartid}`, { headers: { Authorization: `Bearer ${payToken}` } })
            .then((res) => {
                const img = res.data[0].products_img_url;
                setImgurl(img);
                setPageLoading(true);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    function createPayment() {
        const requestBody = {
            total: priceToPay
        };
        axios.post(`${CommonVars.API_URL}/create-payment-intent`, requestBody)
            .then((res) => {
                setStripeData(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        getUserData();
        getCartTotalAmount();
        createPayment();
    }, []);

    const CheckoutForm = () => {
        const stripe = useStripe();
        const elements = useElements();

        // set toast
        const toast = useToast();
        const id = 'payment-toast';
      
        const makePayment = async (event) => {
            event.preventDefault();
            if (!stripe || !elements) {
                // Stripe.js has not loaded yet. Make sure to disable
                // form submission until Stripe.js has loaded.
                return;
            };

            const { error } = await stripe.confirmCardPayment(stripeData.clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement),
                    billing_details: {
                        name: userData.username,
                    },
                },
                receipt_email: userData.email,
            });

            if (!error) {
                setPayLoading(true);
                axios.post(`${CommonVars.API_URL}/users/${userid}/cart/${cartid}/checkout`, {}, {
                    headers: { Authorization: `Bearer ${payToken}` },
                })
                .then((res) => {
                    const orderid = res.data.order_id;
                    // prepare the request body
                    const addressRequestBody = {
                        address: userAddress,
                        orderid: orderid,
                    };
                    console.log(addressRequestBody);
                    // access backend add address api
                    return axios.put(`${CommonVars.API_URL}/users/${userid}/cart/${cartid}/checkout`, addressRequestBody, {
                        headers: { Authorization: `Bearer ${payToken}` },
                    });
                })
                .then(() => {
                    // access back-end to delete from cart after inserting into orders
                    return axios.delete(`${CommonVars.API_URL}/cart/${cartid}/checkout`);
                })
                .catch((err) => {
                    console.log(err);
                })

                // redirect user to orders page if payment succeeded
                if (!toast.isActive(id)) {
                    toast({
                        id,
                        title: 'Payment Successful!',
                        description: "Thank you for your payment!",
                        status: 'success',
                        position: 'top',
                        duration: 3000,
                        isClosable: true,
                    });
                };

                setTimeout(() => {
                    window.location.replace("/orders");
                    setPayLoading(false);
                }, 3000);
            } else {
                if (!toast.isActive(id)) {
                    toast({
                        id,
                        title: 'Payment Unsuccessful!',
                        description: "Please check your payment details!",
                        status: 'error',
                        position: 'top',
                        duration: 2000,
                        isClosable: true,
                    });
                };
                console.log(error);
                setPayLoading(false);
            };
        };
      
        return (
            <Box
                width={{ sm: 'sm', md: 'md', lg: 'lg' }}
                mx='auto'
                my='auto'
                bg='white'
                p={4}
                rounded='lg'
            >
                <Heading pt={4} textAlign={'center'}>Make Payment</Heading>
                <Text pt={2} pb={5} textAlign={'center'}>Product will be shipped after payment.</Text>
                <Image
                    boxSize={{sm: "200px", md: "300px"}}
                    src={img_url}
                    rounded="lg"
                    mx={{ base: "auto"}}
                    shadow="md"
                    mb={8}
                />
                <form id="payment-form" onSubmit={makePayment}>
                    <label htmlFor="card-element">Card Payment</label><br/><br/>
                    <CardElement id="card-element" /><br/>
                    <Button 
                        type="submit"
                        width="100%"
                        bg = 'black'
                        color = 'white'
                        border = '2px solid black'
                        _hover = {{
                            bg: 'white',
                            color: 'black',
                            border: '2px solid black'
                        }}
                    >
                        {payLoading === true ? "Loading..." : `Pay now - $${priceToPay}`}
                    </Button>
                </form>
            </Box>
        );
    };
    
    return (
        <div className="Main">
            <Elements stripe={stripePromise}>
                {pageloading !== true ? 
                    <Flex 
                        minH={'100vh'}
                        align={'center'}
                        justify={'center'}
                        bg={'#F4F4F4'} 
                    >
                        <VStack align="center">
                                <Spinner thickness='9px' speed='0.75s' emptyColor='gray.200' color='blue.500' boxSize={24}/>
                                <Text fontSize={18} pt={6}>Loading Payment...</Text>
                        </VStack>
                    </Flex> : 
                <>
                    <CheckoutForm />
                    <Box 
                        width={{ sm: 'sm', md: 'md', lg: 'lg' }}
                        mx={'auto'}
                        my={'auto'}
                        bg={'white'}
                        p={4}
                        rounded={'lg'}
                        mt={5}
                    >
                        <Text htmlFor={'discountCode'} pb={3}>Discount Code</Text>
                        <form id="discount-form" onSubmit={getDiscountCode}>
                            <Input id="discountCode" type="text"/>
                            <Button 
                                mt={4}
                                type="submit" 
                                width="100%"
                                bg = 'black'
                                color = 'white'
                                border = '2px solid black'
                                _hover = {{
                                    bg: 'white',
                                    color: 'black',
                                    border: '2px solid black'
                                }}>
                                {loading === true ? "Loading..." : "Use Code"}
                            </Button>
                        </form>
                    </Box>
                </>
                }
            </Elements>
        </div>
    )
}

export default PaymentScreen;